import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { ConsoleLoggerService } from '../../../../../core/services/console-logger.service';
import { Tag } from '../../../../../shared/interfaces/tag';
import { SlugifyPipe } from '../../../../../shared/pipes/slugify.pipe';
import { FirestoreService } from '../../../../../shared/services/firestore.service';

@Component({
  selector: 'anon-new-tag',
  templateUrl: './new-tag.component.html',
  styleUrls: ['./new-tag.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewTagComponent {
  tag!: Tag;
  addTagForm = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
    slug: new FormControl('', Validators.required),
    featured: new FormControl(false),
  });

  constructor(
    private slugify: SlugifyPipe,
    private cLog: ConsoleLoggerService,
    private db: FirestoreService,
    private dialogref: MatDialogRef<NewTagComponent>
  ) { }
  get name() { return this.addTagForm.get('name'); }
  get description() { return this.addTagForm.get('description'); }
  get slug() { return this.addTagForm.get('slug'); }
  get featured() { return this.addTagForm.get('featured'); }

  closeDialog() {
    this.dialogref.close();
  }

  setSlug(event: any) {
    this.slug?.setValue(this.slugify.transform(event.target.value));
  }

  async createTag() {
    const tag = this.addTagForm?.value;
    if (await this.db.docExists(`tags/${tag.slug}`)) {
      return this.cLog.error(`tag with slug already exists: ${tag.slug}`);
    }
      this.db.set(`tags/${tag.slug}`, tag)
      .then(() => this.closeDialog());
  }

}
